// extracted by mini-css-extract-plugin
export default {"checkoutContainer":"Checkout_checkoutContainer__DIOHd"};